import { createContext, useContext, useState, useCallback } from 'react';

const GateModalContext = createContext(null);

export const GateModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openGate = useCallback(() => setIsOpen(true), []);
  const closeGate = useCallback(() => setIsOpen(false), []);

  return (
    <GateModalContext.Provider value={{ isOpen, openGate, closeGate }}>
      {children}
    </GateModalContext.Provider>
  );
};

export const useGateModal = () => {
  const ctx = useContext(GateModalContext);
  if (!ctx) throw new Error('useGateModal must be used within GateModalProvider');
  return ctx;
};
